import React from 'react';
import './Pager.scss';

export default function Pager(props) {
    const data = props.data;

    if(data.markComplete){
        props.markComplete();
    }

    return (
        <div className={`Pager ${data.class}`}>
            {/* optional 'extras' fields - creates divs from  extras array that looks like: [{'class':"some class", "content":"Some content"}]*/}
            {Array.isArray(data.extras) && data.extras.map((extra, i) => {
                return <div className={`extra ${extra.class} extra-${i}`}>
                    <div className="text" dangerouslySetInnerHTML={{__html:extra.content}}></div>  
                </div>
            })}

            {/* for image */}
            {data.images && data.images.map((image, i) => {
                return <img src={image.location} style={image.position} key={'image'+i} alt={'image'+i}/>              
            })}
            
            <div className="text-content">
                <h1 className="header" dangerouslySetInnerHTML={{__html:data.header}}></h1>
    
                <div className="body" dangerouslySetInnerHTML={{
                     __html:data.body
                 }}></div>
                
                {(!data.noNext && data.flowButton) &&  <div 
                    id={`next-button`}
                    className="global-button  flow"
                    onClick={props.onComplete}>
                    {data.button || props.globals.nextButtonText}
                </div>}

            </div>
            
            {(!data.noNext && !data.flowButton && !data.restartButton) &&  <div 
                id={`next-button`}
                className="global-button"
                onClick={props.onComplete}>
                {data.button || props.globals.nextButtonText}
            </div>}

            {data.restartButton && <div 
                className="restart-button global-button" 
                onClick={()=> props.resetSco()}>
                    <div className='restart-icon'></div>{data.button}                 
                </div>}

        </div>
    )
}